import React from 'react';
import Card from '../../../components/Campanhas/Card';
import Button from '../../../components/Campanhas/Button';
import * as Style from './style';
import { ReactComponent as Megafone } from '../../../img/Shape.svg';
import color from '../../../config/colors.json';
import CampaignHeader from '../../../components/Campanhas/CampaignHeader';

const CTA = () => (
	<>
		<CampaignHeader>Minhas campanhas</CampaignHeader>
		<div style={{ padding: '30px 38px 0' }}>
			<Card padding="44px 0 52px">
				<div className="row">
					<div className="col-12">
						<div className="d-flex justify-content-center">
							<Megafone fill={color.lightRed} />
						</div>
					</div>
				</div>
				<div className="row" style={{ paddingTop: '37px' }}>
					<div className="col-12">
						<Style.Title>Poxa, você ainda não possui uma campanha ;(</Style.Title>
					</div>
				</div>
				<div className="row" style={{ paddingTop: '31px' }}>
					<div className="col-12">
						<Style.Text>
							Contrate uma campanha pontual ou recorrente, faça sua loja bombar em vendas!
						</Style.Text>
					</div>
				</div>
				<div className="row" style={{ paddingTop: '56px' }}>
					<div className="col-12">
						<div className="d-flex justify-content-center">
							<Button fit fontSize="14px" lineheight="20px" type="link" to="/">
								Contratar campanha
							</Button>
						</div>
					</div>
				</div>
			</Card>
		</div>
	</>
);

export default CTA;
